<section class="h-full flex flex-col gap-2 z-0 relative p-2 lg:pl-0">

    <!-- Top Controls -->
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex gap-2">
          <button routerLink="add" class="btn btn-secondary">Add</button>
        </div>
        <div *ngIf="invoices && invoices.length">
            <h1 class="text-xs text-nowrap text-left">
                Showing {{(numberOfRecords * currentPage) - (invoices.length != numberOfRecords?
                (numberOfRecords
                -invoices.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
            <div class="flex gap-2">
                <div class="relative">
                    <input [(ngModel)]="search" (input)="onSearchInput()" type="text" required placeholder="Search.." class="pl-8" />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                </div>
                <div class="min-w-48">
                    <input type="text" [(ngModel)]="invoiceDateRange" [owlDateTime]="invoiceDate" [owlDateTimeTrigger]="invoiceDate"
                        [selectMode]="'range'" (ngModelChange)="onInvoiceDateChange($event)" placeholder="Invoice Date" />
                    <owl-date-time [pickerType]="'calendar'" #invoiceDate></owl-date-time>
                </div>
                <div>
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCustomerId"
                        (ngModelChange)="onCustomerFilterChange()" [notFoundText]="'No record found'"
                        placeholder="Select Customer" [clearable]="false" [searchable]="true">
                        <ng-option [value]="null">Select Customer</ng-option>
                        <ng-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.DisplayName | titlecase }}
                        </ng-option>
                    </ng-select>
                </div>
                <div>
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedStatus" (ngModelChange)="onStatusFilterChange()"
                        [notFoundText]="'No record found'" placeholder="All Status" [clearable]="false"
                        [searchable]="false">
                        <ng-option value="">All Status</ng-option>
                        <ng-option value="created">Created</ng-option>
                        <ng-option value="pending">Pending</ng-option>
                                        </ng-select>
                </div>
                <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
                    <button [appToolTip]="'Filter'" type="button" (click)="toggleDropdown($event)" [disabled]="!selectedInvoiceIds.length" class="btn btn-secondary disabled:opacity-50 disabled:cursor-not-allowed" id="menu-button"
                        aria-expanded="true" aria-haspopup="true">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                        </svg>
                        <span *ngIf="selectedInvoiceIds.length" class="flex absolute h-3 w-3 -top-1 -right-1">
                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
                            <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                        </span>
                    </button>
                    <div *ngIf="isDropdownOpen"
                        class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                        role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                        <div class="p-3 grid grid-cols-2 gap-2" role="none">
                            <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1">
                                <div class="p-1 grid grid-cols-1 gap-1">
                                    <button *ngIf="selectedInvoiceIds.length" type="button" class="btn btn-primary text-xs"
                                        (click)="isPayModalOpen = true; isDropdownOpen = false">
                                        Invoice Payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedInvoiceIds.length" class="w-40 rounded-xl bg-gray-200 dark:bg-zinc-950 px-2 py-2">
        <dl class="flex items-center">
            <dd class="w-full truncate text-right">
                <div class="text-xs text-main-light flex-1"> Selected Invoices </div>
                <div class="text-sm font-bold text-main-secondary flex-1 truncate">{{ selectedInvoiceIds.length }}</div>
            </dd>
        </dl>
    </div>

    <div class="flex-shrink-0">
        <h2><label class="font-bold" for="">Amount</label></h2>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div *ngFor="let card of amountStatCards"
                class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            class="h-8 w-8 text-base-dark">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </dt>
                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
                        <div class="text-xl font-bold text-base-dark flex-1 truncate">${{ (stats[card.key] || 0) | number:'1.2-2' }}</div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0">
        <h2><label class="font-bold" for="">Invoices</label></h2>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div *ngFor="let card of statusStatCards"
                class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            class="h-8 w-8 text-base-dark">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                        </svg>
                    </dt>
                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
                        <div class="text-xl font-bold text-base-dark flex-1 truncate">{{ stats[card.key] || 0 }}</div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>

    <!-- Table Wrapper -->
    <div
        class="flex-1 min-h-0 overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">#</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <input type="checkbox" [checked]="invoices.length && selectedInvoiceIds.length === invoices.length"
                                            (change)="toggleAllInvoices($any($event.target).checked)" />
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Actions</th>
                             <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Id</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Date</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Due Date</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Invoice No.
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">SKU</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Reference</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Company</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Customer</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Amount</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">QB Reference
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Payment Status</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950
                             text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Status</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let invoice of (invoices | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i + 1}}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <input type="checkbox" [checked]="selectedInvoiceIds.includes(invoice.id)" (change)="toggleInvoice(invoice.id)" />
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex gap-2 items-center">
                                            <a [appToolTip]="'Edit'" (click)="openInvoiceFormWindow(invoice.id)" href="javascript:void(0)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400"><svg
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="2" stroke="currentColor" class="size-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10">
                                                    </path>
                                                </svg>
                                            </a>
                                            <div class="inline-flex relative">
                                                <!-- *ngIf="!assign.isJClone" -->
                                                <a [appToolTip]="'More Actions'" href="javascript:void(0)" (click)="showActionButtons(i)"
                                                    class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                    </svg>
                                                </a>
                                                <div (outsideClick)="closeActionMenu($event)" outside-click
                                                    *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                                    class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                                    role="menu" aria-orientation="vertical"
                                                    aria-labelledby="menu-button" tabindex="-1">
                                                    <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                                                    <app-qb-action-dropdown
                                                        class="divide-y divide-zinc-950/10 dark:divide-white/10"
                                                        [source]="'invoice'"
                                                        [invoice]="invoice" (download)="downloadInvoice($event)"
                                                        (delete)="deleteInvoice($event)" (send)="sendInvoice($event)"
                                                        (detail)="openDetailModal($event)"
                                                        (pullFrom)="onSyncInvoice(invoice, 'pull')" (pushTo)="onSyncInvoice(invoice, 'push')"
                                                        (receivePayment)="openReceivePayment(invoice.id)"
                                                    ></app-qb-action-dropdown>
                                                </div>
                                            </div>

                                            <!-- <button (click)="onSyncInvoice(invoice.id)" class="btn btn-primary text-xs">
                                                <svg [ngClass]="{'animate-spin': loadingId === invoice.id}"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                </svg>
                                                Sync
                                            </button> -->
                                        </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{invoice.Id}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((invoice.TxnDate || invoice.createdAt) | date: 'MM/DD/YYYY') || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(invoice.DueDate | date: 'MM/DD/YYYY') || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{invoice.DocNumber || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{invoice.Sku || 'N/A'}}
                                    </td>
                                       <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     <div class="flex flex-col gap-0.5 leading-tight">
                  <!-- reference Name -->
                  <span class="block max-w-[200px] truncate">
                    {{ ((invoice.reference?.name) | titlecase) || 'N/A'}}
                  </span>
                  
                  <!-- reference ID -->
                  <button type="button" (click)="openReference(invoice.reference)" [disabled]="!invoice.reference?.id"
                    class="text-[12px] text-blue-400 bg-blue-50 px py-0.5 rounded-md w-fit font-mono tracking-wide cursor-pointer hover:underline">
                    {{ (invoice.reference?.id || '').split(',')[0].slice(0, 8) || 'N/A' }}
                    <span *ngIf="(invoice.reference?.id || '').split(',').length > 1">+{{ (invoice.reference?.id || '').split(',').length - 1 }}</span>
                  </button>
                  </div>
                  </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((invoice.company?.CompanyName) | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((invoice.CustomerRef.name) | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    ${{invoice.TotalAmt || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{invoice.Id || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex flex-col gap-0.5 leading-tight">
                      <span class="w-fit" [ngClass]="invoice.paymentStatusClass">{{ invoice.paymentStatus?.label || 'N/A' }}</span>
                      <span *ngIf="invoice.paymentStatus?.subLabel" class="text-[12px] text-zinc-500 dark:text-zinc-400">{{ invoice.paymentStatus?.subLabel }}</span>
                    </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span
                                            [ngClass]="invoice.status == 'created' ? 'badge-primary' : 'badge-success'">{{(invoice.status
                                            | titlecase) || 'N/A'}}</span>
                                    </td>
                                </tr>
                                <!-- Add more rows -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>
</section>

<app-batch-payment-modal *ngIf="isPayModalOpen" [count]="selectedInvoiceIds.length" [loading]="paying"
    (confirm)="onPaySelected($event)" (closeModal)="isPayModalOpen = false"></app-batch-payment-modal>

<app-invoice-detail-modal *ngIf="invoiceDetail" [invoiceDetail]="invoiceDetail"
    (closeModal)="invoiceDetail = null"></app-invoice-detail-modal>

<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" [source]="'fundingsourceBilling'"
    (closeModal)="tripId = null"></app-trip-detail-modal>
<app-reference-picker-modal *ngIf="referencePicker" [reference]="referencePicker"
    (selectId)="tripId = $event; referencePicker = null" (closeModal)="referencePicker = null"></app-reference-picker-modal>
